<div class="total-status">
    <div class="order-total">{{total | currency}}</div>
    <div class="item-status">{{statusDisplay}}</div>
    <div class="item-count">({{itemTotal}})</div>
</div>
